// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1bbacd3e","766":"adffa5c7"}[chunkId] + ".chunk.js";
};